export default __webpack_public_path__ + "media/images/titre-ongletleft-2041accacb3357b84821336eec0b6e0a.png";